import React, { useEffect, useState } from "react";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { t } from "i18next";


const CustomAutocomplete = <T,>({
  label = "",
  fetchData,
  placeholder = "",
  options = [],
  onChange,
  getOptionLabel: originalGetOptionLabel,
  name,
  id,
  withChecked,
  error,
  InputChange,
  value,
  maxLength = 0,
}: ICustomAutocompleteProps<T>) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [filteredOptions, setFilteredOptions] = useState<T[]>(options);
  const [showIcon, setShowIcon] = useState(false);
  const [maxLengthError, setMaxLengthError] = useState(false);

  useEffect(() => {
    if (inputValue.trim() === "" || inputValue.trim().length == 1) {
      setFilteredOptions([]);
      return;
    }

    const debounce = setTimeout(async () => {
      if (fetchData) {
        const fetchedData = await fetchData(inputValue);
        setFilteredOptions(fetchedData || []);
      }
    }, 500);

    return () => clearTimeout(debounce);
  }, [inputValue, fetchData]);

  useEffect(() => {
    if(value){
      setInputValue(value);
    }
  }, [value]);

  const handleInputChange = async (event: React.SyntheticEvent, value: string) => {
    setMaxLengthError(value.length > maxLength);
    setInputValue(value);
    if (InputChange) InputChange(value);
  };

  const handleChange = (event: React.SyntheticEvent, value: T | string | null) => {
    setInputValue(typeof value === "string" ? value : value ? originalGetOptionLabel(value) : "");
    if (onChange) onChange(value);
  };

  const handleOutFocus = () => {
    if (withChecked) {
      setShowIcon(!!inputValue && !!withChecked && !error);
      setInputValue(inputValue.trim().slice(0,maxLength));
      setMaxLengthError(false);
    }
  };

  const handkeFocused = async () => {
    if (withChecked) {
      setShowIcon(false);
}
  };

  return (
    <div className={`component__input`}>
      <Autocomplete
        options={filteredOptions}
        getOptionLabel={originalGetOptionLabel}
        filterOptions={(x) => x}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            id={id}
            name={name}
            label={label}
            placeholder={placeholder}
            error={error ? error : maxLengthError ? true : false}
            // helperText={maxLengthError ? maxLength + t("validation.limitText") : ""}
            size="small"
            inputProps={{... params.inputProps, "maxLength": maxLength}}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "&::after": {
                  content: '""',
                  display: showIcon ? "block" : "none",
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: 14,
                  height: 10,
                  backgroundImage: 'url("/images/ico_check.svg")',
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  pointerEvents: "none",
                },
                "&:hover::after": {
                  display: "none",
                  transition: "opacity 0.3s ease, transform 0.3s ease",
                },
              },
            }}
            onFocus={handkeFocused}
            onBlur={handleOutFocus}
          />
        )}
        renderOption={(props, option: any) => (
          <li {...props} key={option.lbc}>
            <Box style={{
              width: "100%",
            }}>
              <Typography variant="body1" sx={{
                fontSize: 14,
                margin: "0 0 10px",
                color: " #444",
              }}>
                {option.cname}
              </Typography>
              <Typography variant="body2" sx={{
                fontSize: 12,
                padding: "0 5px",
                color: " #888",
              }}>
                {option.addr
                }</Typography>
              <div style={{
                margin: "4px 0",
                borderTop: "1px solid #ccc",
              }} />
            </Box>
          </li>
        )}
        freeSolo
      />
    </div>
  );
};

export default CustomAutocomplete;
